/* global axios */
import ApiClient from './ApiClient';

class UserNotificationSettings extends ApiClient {
  constructor() {
    super('notification_settings', { accountScoped: true });
  }

  update(params) {
    return axios.patch(`${this.url}`, params);
  }

  companies() {
    return axios.get(`${this.url}/companies`);
  }

  applyToCompanies(params) {
    return axios.patch(`${this.url}/apply_to_companies`, params);
  }
}

export default new UserNotificationSettings();
